import { useContext, useMemo } from "react";
import { PLATFORM_USER_ACTIONS } from "../../utils/constants";
import { BootstrapContext } from "../../contexts/BootstrapContext";

export const useCheckUserPermission = (action, integration = null) => {
  const {
    actionToRole,
    user,
    isSuccess,
    isLoading,
  } = useContext(BootstrapContext);

  const permitted = useMemo(() => {
    if (!isSuccess || !user) return false;

    if (action === PLATFORM_USER_ACTIONS.MODIFY_INTEGRATION) {
      const ownUserIntegration = user.ownerships || [];
      if (integration && ownUserIntegration.includes(integration)) {
        return true;
      }
    }

    const authorizedRoles = actionToRole[action] || [];
    const userRole = user.access_role;
    return authorizedRoles.includes(userRole);
  }, [isSuccess, user, action, integration, actionToRole]);

  return {
    permitted,
    isSuccess,
    isFetching: isLoading,
  };
};
